import { COPILOT_MESSAGE_TAG } from "../types/CommonTypes";

const DATA_CATEGORY_STYLES: Record<
  string,
  { color: string; bgColor: string; label: string }
> = {
  historical: { color: "#16E099", bgColor: "#E2FFE3", label: "Historical" },
  live: { color: "#059669", bgColor: "#ECFDF5", label: "Live" },
  scheduled: { color: "#FCB888", bgColor: "#FDF4D1", label: "Scheduled" },
};

export function mapDataCategoryToTags(
  dataCategory?: string | string[]
): COPILOT_MESSAGE_TAG[] | undefined {
  if (!dataCategory) return undefined;
  const categories = Array.isArray(dataCategory)
    ? dataCategory
    : dataCategory
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
  return categories
    .map((c) => DATA_CATEGORY_STYLES[c.toLowerCase()])
    .filter(Boolean)
    .map(({ color, bgColor, label }) => ({ label, color, bgColor }));
}

const PROMINENT_ENTITY_BORDER = "#BFDBFE";
const PROMINENT_ENTITY_TEXT = "#1E40AF";
const PROMINENT_ENTITY_BG = "#FFFEFF6F";

export function mapProminentEntitiesToTags(
  entities?: string[]
): COPILOT_MESSAGE_TAG[] {
  if (!entities || entities.length === 0) return [];
  return entities.map((label) => ({
    label,
    color: PROMINENT_ENTITY_BORDER,
    bgColor: PROMINENT_ENTITY_BG,
    textColor: PROMINENT_ENTITY_TEXT,
  }));
}
